import {
  commonUIColorKeys,
  type CommonUIColorKeys,
} from '@decisiv/ui-components/lib/utils/commonUIColors';

import * as yup from 'yup';

export const tagInputSchema = yup.lazy((value) => {
  if (typeof value === 'string') {
    return yup.string().required();
  }

  return yup.object({
    text: yup.string().required(),
    color: yup
      .mixed<CommonUIColorKeys>()
      .oneOf(Object.values(commonUIColorKeys)),
  });
});
